import React from 'react';
import {
    HOME_COLUMN,
    DRAW_COLUMN,
    AWAY_COLUMN,
    THREE_WAY_COLUMN_LENGTH,
} from '../../../shared/components/selection/constants';


/**
 * Orders the sport market headers
 * @param  {Object} marketHeaders   the market header objects
 * @param  {Number} numberOfColumns the number of columns
 * @return {Array}  the ordered column names
 */
export function orderSportMarketHeaders(marketHeaders, numberOfColumns) {
    const homeColumn = marketHeaders[HOME_COLUMN];
    const drawColumn = marketHeaders.hasOwnProperty(DRAW_COLUMN) ? marketHeaders[DRAW_COLUMN] : '';
    const awayColumn = marketHeaders[AWAY_COLUMN];

    return numberOfColumns === THREE_WAY_COLUMN_LENGTH ? [homeColumn, drawColumn, awayColumn] : [homeColumn, awayColumn];
}

/**
 * Disabled button for non betable selections in
 * SelectionNameGrouping and OverUnderGrouping components
 * @param {any} key for react index in an array of componets
 *
 * @returns {JSX} The jsx component for a disabled bet button
 */
export const disabledButton = (key) => (
    <div className="bet-button" key={key}>
        <span className="bb-sport-event__selection bb-sport-event__selection--inactive"></span>
    </div>
);
